(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["fixed-attribution-icon"] = factory();
	else
		root["fixed-attribution-icon"] = factory();
})(self, function() {
return 